import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Edit20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.8839 1.82321C14.3958 1.33505 13.6043 1.33505 13.1162 1.82321L2.33603 12.6034L0.8484 17.5621C0.648163 18.2296 1.27047 18.8519 1.93793 18.6516L6.89669 17.164L17.6768 6.38387C18.165 5.89572 18.165 5.10426 17.6768 4.6161L14.8839 1.82321ZM12.0607 4.99999L14.0001 3.06065L16.4394 5.49999L14.5001 7.43933L12.0607 4.99999ZM11.0001 6.06065L3.6641 13.3966L2.61867 16.8814L6.10344 15.8359L13.4394 8.49999L11.0001 6.06065Z'
      fill='currentColor'
    />
  </Svg>
);

Edit20.displayName = 'Edit20';
export default Edit20;
